import React from 'react';
import { useSessionCollectionName } from '@/platform-services/session';
import { InitialSelectionPage } from '@/search-for-retail/generic/page-context-selection';
export const CollectionPageWrapper = ({ titleMessageKey, children, titleBadge, }) => {
    const activeCollection = useSessionCollectionName();
    return (<React.Fragment>
      {!activeCollection
            ? <InitialSelectionPage titleMessageKey={titleMessageKey} selectionMessageKey='SELECT_COLLECTION_PAGE_TEXT' titleBadge={titleBadge}/>
            : children}
    </React.Fragment>);
};
export default CollectionPageWrapper;
